// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"403":"8d84237a","726":"8d84237a"}[chunkId] + ".chunk.css";
};